/**
 * File: block-image-text.js
 *
 * Removes the top margin from `.jh-block-outer-container` elements when they
 * are directly preceded by another `.jh-block-outer-container` element.
 * This helps to remove extra spacing between consecutive blocks of this type.
 */
document.addEventListener('DOMContentLoaded', () => {
	const blocks = document.querySelectorAll('.jh-block-outer-container');

	blocks.forEach((block) => {
		const prevElement = block.previousElementSibling;

		if (prevElement && prevElement.classList.contains('jh-block-outer-container')) {
			block.style.marginTop = '0';
		}
	});
});
